import styled from 'styled-components';

export const ZendeskButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 3;

  width: 60px;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  outline: transparent;
  border: transparent;
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);

  background: #4d46df;

  cursor: pointer;

  img {
    width: 28px;
    height: 28px;
  }
`;
